module.exports = __webpack_public_path__ + "static/media/succot.63167d05.svg";